import LEGACY_VIEWER, { V4_ENTRY_PATH } from '../../../constants/legacy-viewer';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import APP_PATHS from '../../../constants/app-paths';
import APP_ROUTES from '../../../constants/app-routes';
import AppLoadingPage from '../../../pages/app-loading';
import CAPABILITIES from '../../../constants/capabilities';
import LazyLayout from '../../../layouts/lazy';
import React from 'react';
import SecondaryLayout from '../../../layouts/secondary';
import getLocationWithState from '../../../utilities/routing/get-location-with-state';
import lazyDependencies from './index.lazy';
import useReturnToPath from '../../../hooks/routing/use-return-to-path';
import { useTranslation } from 'react-i18next';
import useUserContext from '../../../hooks/context/use-user-context';

//

function SignInRoutes() {
  const labUser = useUserContext();
  const { t: viewerText } = useTranslation('legacy-viewer');
  const location = useLocation();
  const returnToPath = useReturnToPath();

  const [firstLogin, setFirstLogin] = React.useState(false);

  // Event Handlers

  function handleAccountCreation() {
    setFirstLogin(true);
    handleLogin();
  }

  function handleLogin(pendingLabUser) {
    // We can't know which profile a user will want to select after a fresh login, so clear any
    // previous state to force a profile selection. This also handles the case where multiple users
    // are using the same computer/device
    labUser.setActiveStudentId(undefined);

    if (pendingLabUser && !pendingLabUser.capabilities.includes(CAPABILITIES.labAccess)) {
      labUser.setPendingUser(pendingLabUser);
      return;
    }

    labUser.refetch();
  }

  //
  // Render

  if (labUser.loading) {
    return <AppLoadingPage />;
  }

  if (LEGACY_VIEWER && location.pathname === APP_PATHS.createAccount) {
    return (
      <SecondaryLayout withoutLabBranding>
        <a href={V4_ENTRY_PATH}>{viewerText('openV4')}</a>
      </SecondaryLayout>
    );
  }

  if (labUser.authenticated) {
    const returnToLocation = !returnToPath
      ? location.state?.from
      : {
          pathname: returnToPath.split('?')[0].replace('/learning-lab', ''),
          search: returnToPath.substring(returnToPath.indexOf('?')),
        };
    return (
      <Redirect
        to={{
          pathname: APP_PATHS.home,
          ...returnToLocation,
          state: {
            firstLogin,
          },
        }}
      />
    );
  }

  if (labUser.unsupportedRole) {
    if (!labUser.hasCapability(CAPABILITIES.newUserCreation)) {
      return <Redirect to={APP_PATHS.unsupportedRole} />;
    }

    if (location.pathname !== APP_PATHS.createAccount) {
      return <Redirect to={getLocationWithState(APP_PATHS.createAccount, location)} />;
    }
  }

  return (
    <LazyLayout layout={SecondaryLayout} withoutLabBranding>
      <Switch>
        <Route exact path={APP_ROUTES.createAccount}>
          <lazyDependencies.CreateAccountPage onAccountCreation={handleAccountCreation} />
        </Route>

        <Route exact path={APP_ROUTES.login}>
          <lazyDependencies.LoginPage onLogin={handleLogin} />
        </Route>
      </Switch>
    </LazyLayout>
  );
}

// Exports
// -------

export default SignInRoutes;
